import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";

import { Comment, PutComment, putComment } from "@/api";
import { useUser } from "@/providers/context";
import { useUserDetails } from "@/hooks";

type PutCommentValue = Omit<PutComment, "userId" | "userName">;

export const usePutComment = () => {
  const { user_name: userName, uid: userId } = useUser();
  const { data: userDetails } = useUserDetails();

  const thumbnailSource = userDetails?.avatar_url ?? undefined;

  const queryClient = useQueryClient();
  return useMutation<
    Comment[],
    AxiosError<{ detail: string }>,
    PutCommentValue
  >(
    ({ comment, itemId, itemType, dataSource, sourceId, parentCommentId }) => {
      if (!userId || !userName) {
        throw Error("Error Putting comment, missing user details");
      }
      return putComment({
        comment,
        dataSource,
        itemId,
        itemType,
        userId,
        sourceId,
        parentCommentId,
        userName,
        thumbnailSource,
      });
    },
    {
      onSuccess: (data, variables) => {
        // Update the local comments immediately with the response from the PUT
        queryClient.setQueryData(["comments", variables.itemId], data);
      },
    },
  );
};
